<template>
  <div>
    <h2>
      {{ $t('formulationRepository.detailPage.detailsTable.headline') }}
    </h2>

    <table class="ce-dataTable">
      <tbody>
        <tr
          v-for="(row, index) in rows"
          :key="row.label"
          :style="(index + 1) % 2 ? 'background: ' + fadedBgColor : ''">
          <td>
            {{ row.label }}
          </td>
          <td>
            {{ row.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('generic', ['industries']),
    ...mapState(['formulation', 'shade', 'fieldManifest']),
    ...mapGetters(['fadedBgColor']),
    colorSpaceConfig() {
      return this.fieldManifest.color_space;
    },
    shadeColorSpaceValue() {
      return this.colorSpaceConfig.options[this.shade.color] ?? null;
    },
    topics() {
      if (this.shade.topics && Array.isArray(this.shade.topics)) {
        return this.shade.topics;
      }

      return [];
    },
    topicsList() {
      if (this.topics.length > 0) {
        return this.topics.map((topic) => topic.title).join(', ');
      }

      return null;
    },
    tags() {
      if (this.formulation.tags && Array.isArray(this.formulation.tags)) {
        return this.formulation.tags;
      }

      return [];
    },
    tagsList() {
      if (this.tags.length > 0) {
        return this.tags.map((tag) => tag.title).join(', ');
      }

      return null;
    },
    formulationIndustries() {
      if (this.formulation.industries && Array.isArray(this.formulation.industries)) {
        return this.industries.filter((ind) => this.formulation.industries.includes(ind.code));
      }

      return [];
    },
    formulationIndustriesList() {
      if (this.formulationIndustries.length > 0) {
        if (this.industries.length === this.formulationIndustries.length) {
          return this.$t('formulationRepository.allIndustries');
        }

        return this.formulationIndustries.map((industry) => industry.title).join(', ');
      }

      return null;
    },
    rows() {
      const rows = [
        {
          label: this.$t('formulationRepository.detailPage.detailsTable.shadeName'),
          value: this.shade.title
        }
      ];

      if (this.shade.color) {
        rows.push({
          label: this.colorSpaceConfig.title,
          value: this.shadeColorSpaceValue,
        });
      }

      if (this.topics.length > 0) {
        rows.push({
          label: this.$t('formulationRepository.detailPage.detailsTable.topics', this.topics.length),
          value: this.topicsList
        });
      }

      if (this.tags.length > 0) {
        rows.push({
          label: this.$t('formulationRepository.detailPage.detailsTable.tags', this.tags.length),
          value: this.tagsList,
        });
      }

      if (this.formulationIndustries.length > 0) {
        rows.push({
          label: this.$t('formulationRepository.detailPage.detailsTable.industries', this.formulationIndustries.length),
          value: this.formulationIndustriesList
        });
      }

      return rows;
    }
  }
};
</script>
